
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { collapseGroupDropdown, initCollapseDropdownFilter } from '@app/helpers/scripts';
import { IDataGrouped } from '@app/interfaces/idata-grouped';
import { PlatformService } from '@app/services/platform.service';

@Component({
  selector: 'form-group-radio-multi-accordion',
  templateUrl: './form-group-radio-multi-accordion.component.html'
})
export class FormGroupRadioMultiAccordionComponent {

  @Input() control: FormControl;
  @Input() id: string = '';
  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() messageRequired: string = '';
  @Input() placeholderSearch: string = '';
  @Input() dataSelectGroup: Array<IDataGrouped> = [];
  @Input() textSelectAllGroup: string = '';
  @Input() enabledFilter: boolean = true;
  @Input() messageFooter: string = '';
  @Input() messageFooterAction: string = '';
  @Input() style: 'purple' | 'default' = 'default';
  @Output() eventActionFooter = new EventEmitter<any>();

  constructor(private platformService: PlatformService) { }

  ngAfterViewInit() {
    if (this.platformService.isPlatformBrowser) {
      initCollapseDropdownFilter(this.id);
      collapseGroupDropdown();
    }
  }

  onUncheckRadio(value: string) {
    if (this.control.value === value) {
      this.control.setValue('');
    }
  }

  onClickActionFooter(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.eventActionFooter.next(null);
  }
}
